import { LOGIST_INBOX_STATUS_LABELS, type LogistEtrnInbox } from '@entities/logistics';
import {
  Table,
  Th,
  Td,
  Badge,
  ActionRow,
  SmallBtn,
  EmptyState,
} from './styles';
import { inboxTone } from './helpers';

interface LogistInboxTableProps {
  inbox: LogistEtrnInbox[];
  can_write: boolean;
  enabled: boolean;
  onOpenDelivery: (item: LogistEtrnInbox) => void;
  onAutomatch: (id: string) => void;
  onSkip: (id: string) => void;
}

export function LogistInboxTable({
  inbox,
  can_write,
  enabled,
  onOpenDelivery,
  onAutomatch,
  onSkip,
}: LogistInboxTableProps) {
  if (inbox.length === 0) {
    return <EmptyState>Входящих ЭТрН пока нет.</EmptyState>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <Th>Документ</Th>
          <Th>Отправитель</Th>
          <Th>Груз</Th>
          <Th>Масса, кг</Th>
          <Th>Дата</Th>
          <Th>Юр-статус</Th>
          <Th>Обработка</Th>
          {can_write && <Th>Действия</Th>}
        </tr>
      </thead>
      <tbody>
        {inbox.map((i: LogistEtrnInbox) => (
          <tr key={i.id}>
            <Td>{i.doc_number ?? i.external_id}</Td>
            <Td>{i.shipper_name ?? '—'}</Td>
            <Td>{i.cargo_name ?? '—'}</Td>
            <Td>{i.net_mass_kg ?? '—'}</Td>
            <Td>{i.doc_date ?? '—'}</Td>
            <Td>{i.operator_status ?? '—'}</Td>
            <Td>
              <Badge $tone={inboxTone(i.status)}>{LOGIST_INBOX_STATUS_LABELS[i.status]}</Badge>
            </Td>
            {can_write && (
              <Td>
                <ActionRow>
                  <SmallBtn
                    disabled={!enabled}
                    title={
                      enabled
                        ? 'Оформить приёмку груза — часть накладной со стороны получателя'
                        : 'Обмен с оператором выключен'
                    }
                    onClick={() => onOpenDelivery(i)}
                  >
                    Принять груз
                  </SmallBtn>
                  <SmallBtn
                    disabled={i.status === 'skipped' || i.status === 'linked'}
                    onClick={() => onAutomatch(i.id)}
                  >
                    Подобрать
                  </SmallBtn>
                  <SmallBtn
                    disabled={i.status === 'skipped' || i.status === 'linked'}
                    onClick={() => onSkip(i.id)}
                  >
                    Пропустить
                  </SmallBtn>
                </ActionRow>
              </Td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
